<template>
  <b-tabs card nav-class="pt-3 pl-2" class="tabs" v-model="tab" :key="tab">
    <b-tab title="Projects">
      <b-button v-b-toggle.create-project variant="primary">Create New Project</b-button>&nbsp;&nbsp;&nbsp;
      <!--<b-button v-b-toggle.connect-database variant="primary">Connect to a Database</b-button>-->
      
      <b-collapse id="create-project" class="mt-2">
        <b-card>
          <b-row class="my-1">
            <b-col md="3">
              <label for="project-name">Project Name:</label>
            </b-col>
            <b-col md="9">
              <b-form-input
                id="project-name"
                size="md"
                v-model="name"
                type="text"
                placeholder="Name"
                :state="!name ? false : null"
                required />
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col md="3">
              <label for="project-description">Project Description:</label>
            </b-col>
            <b-col md="9">
              <b-form-textarea
                id="project-description"
                size="md"
                rows="3"
                v-model="description"
                placeholder="Description" />
            </b-col>
          </b-row>
          <b-button
            variant="primary"
            class="px-5 mt-2"
            @click="saveChanges"
            :disabled="isSaving"
            style="float: right">
            <i class="fa fa-spin fa-spinner mr-2" v-if="isSaving"/>
            <span>Save&nbsp;</span>
          </b-button>
        </b-card>
      </b-collapse>
      <b-collapse id="connect-database" class="mt-2">
        <b-card>
          <!-- SELECT DATABASE SOURCE TYPE -->
          <b-row class="mb-3 pb-3" style="border-bottom: 1.5px #999 dashed">
            <b-col cols :md=6>
              <h5>1. Select Database Type</h5>
              <b-form-select
                v-model="source"
                :options="sources"
                disabled-field="notEnabled"
                style="max-width: 300px;"
                size="lg"
                >
              </b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="source != null" class="my-1">
            <b-col md="2">
              <label for="host">Host:</label>
            </b-col>
            <b-col md="4">
              <b-form-input
                id="host"
                size="md"
                v-model="dbHost"
                type="text"
                placeholder="Database Host"
                :state="!dbHost ? false : null"
                required />
            </b-col>
            <b-col md="2">
              <label class="pl-3" for="port">Port:</label>
            </b-col>
            <b-col md="4">
              <b-form-input
                id="port"
                size="md"
                v-model="port"
                type="number"
                placeholder="Port"
                :state="!port ? false : null"
                required />
            </b-col>
          </b-row>
          <b-row v-if="source != null" class="my-1">
            <b-col md="2">
              <label for="username">Username:</label>
            </b-col>
            <b-col md="4">
              <b-form-input
                id="username"
                size="md"
                v-model="username"
                type="text"
                placeholder="Username"
                 />
            </b-col>
            <b-col md="2">
              <label class="pl-3" for="password">Password:</label>
            </b-col>
            <b-col md="4">
              <b-form-input
                id="password"
                size="md"
                v-model="password"
                type="password"
                placeholder="Password"
                 />
            </b-col>
          </b-row>
          <b-row v-if="source != null" class="my-1">
            <b-col md="2">
              <label for="database">Database:</label>
            </b-col>
            <b-col md="4">
              <b-form-input
                id="database"
                size="md"
                v-model="database"
                type="text"
                placeholder="Database"
                :state="!database ? false : null"
                required />
            </b-col>
            <b-col md="2" v-if="(source != null) && (source === 'mongo')">
              <label class="pl-3" for="authSource">Authentication DB:</label>
            </b-col>
            <b-col md="4" v-if="(source != null) && (source === 'mongo')">
              <b-form-input
                id="authSource"
                size="md"
                v-model="authSource"
                type="text"
                placeholder="Authentication DB" />
            </b-col>
          </b-row>
          <b-button
            variant="primary"
            class="px-5 mt-2"
            @click="saveDatabaseSource"
            :disabled="isSaving"
            style="float: right">
            <i class="fa fa-spin fa-spinner mr-2" v-if="isSaving"/>
            <span>Connect to Database&nbsp;</span>
          </b-button>
        </b-card>
      </b-collapse>
      <b-row class="my-1" v-if="projects.length > 0">
        <!-- <b-col md="3">
          <label for="project-description">Select a Project:</label>
        </b-col> -->
        <b-col md="12">
          <!-- <b-form-select
            v-model="selectedProject"
            :options="projects"
            value-field="id"
            text-field="name"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="md"
            @change="selectProject()">
          </b-form-select> -->
          <project-list
            class="mb-2; mt-2"
            action-text="select-project"
            :enableAction="true"
            :values="projects"
            :filter="filter"
            :active="true"
            :rowCount="projects.length"
            :defaultColumns="defaultCols"
            @checked="checkedProject"
            >

          </project-list>
        </b-col>
      </b-row>
    </b-tab>
    <b-tab title="Data">
      <files 
        :allFiles="files">
      </files>
    </b-tab>
  </b-tabs>
</template>

<script>
  import axios from "axios";
  import { fullURL } from "../../utils";
  import AgentsList from "../CustomReportsManager/AgentsList";
  import Files from "./Files";
  import {registerListener, unregisterListener} from '../../tasks';
  import ProjectList from "../CustomReportsManager/ProjectList";
  import { saveProject, fetchActiveProject, updateActiveProject } from "../../store/files";
  import moment from "moment";

  export default {
    name: 'FileProject',
    components: {
      Files,
      ProjectList
    },
    props: {
      step: Number
    },
    
    data() {
      return {
        tab: 0,
        isSaving: false,
        // projects: [], // this.$store.state.files.projectList,
        selectedProject: null,
        user: this.$store.state.general.user,
        dataSources: [],
        source: null,
        database: null,
        dbHost: null,
        port: null,
        username: null,
        password: null,
        authSource: null,
        project: this.$store.state.files.activeProject,
        name: null,
        description: null,
        // defaultCols: [],
        filter: {
          method: undefined,
          values: undefined
        }
      };
    },

    mounted() {
      // this.projects = this.getProjects();
    },

    watch: {
      tab() {
        console.log("Checking tab: ", this.tab);
        if (this.tab == 0) {
          this.$emit('create', {'save': true});
        }
        else {
          this.$emit('create', {'save': false});
        }
      }
    },

    methods: {
      handleClose() {
        console.log("Project: ", this.project);
        this.$emit('close');
      },

      goToFiles() {
        this.$router.push(`/sources/files`);
      },
      
      getFiles() {
        var files = [];
        this.$store.state.files.fileList.forEach(f => {
          // f['createdAt'] = this.formatDate(f['createdAt']);
          files.push(f);
        });
        return files;
      },

      getActiveProject(id) {
        var project = null;
        this.$store.state.files.projectList.forEach(p => {
          if (p['_id'] === id) {
            project = p;
          }
        });
        return project;
      },

      checkedProject(value, event) {
        console.log("Checked Project: ", value);
        var activeProject = this.getActiveProject(value['id']);
        this.$store.state.files.activeProject = activeProject;
        updateActiveProject(activeProject);
        this.$emit('success');
        this.handleClose();
      },

      selectProject() {
        console.log("Selected Project: ", this.selectedProject);
        // this.$store.state.activeProject = this.project;
        updateActiveProject(this.getActiveProject(this.selectedProject));
        this.$emit('success');
        this.handleClose();
      },

      saveChanges() {
        this.isSaving = true;
        var data = {"name": this.name};
        if (!!this.description) {
          data["description"] = this.description;
        }
        
        this.$store.dispatch(saveProject(this.name, this.description))
          .then(() => {
            // console.log("Project Save: ", data);
            this.$bvToast.toast('Project has been created successfully: ' + this.name, {
              title: 'Successful',
              autoHideDelay: 5000000,
              variant: 'success',
              solid: true
            });
            this.projects = this.getProjects();
            this.isSaving = false;
            this.$emit('success');
            // this.$store.dispatch(fetchActiveProject())
            // .then(() => {
            //   this.$emit('success');
            // })
            // .catch(console.log)
            // .finally(() => {
            //   this.isSaving = false;
            // });
          })
          .catch(console.log)
          .finally(() => {
            this.isSaving = false;
          });
        
        /* axios.post(fullURL(`/project`), data).then(({data}) => {
            console.log("Project: ", data);
            this.isSaving = false;
            this.$store.state.files.projectList.push(data);
            this.project = data;
            
            axios.post(fullURL(`/project/active`), {projectID: data['_id']}).then(({data}) => {
                console.log("Active Project: ", data);
                if (!this.$store.state.files.projectList) {
                  axios.post(fullURL(`/project/all`), {}).then(({data}) => {
                    this.$store.state.files.projectList = data;
                  });
                }
                this.$store.state.files.projectList.forEach(project => {
                  if (project['_id'] === data['project']) {
                    this.$store.state.files.activeProject = project;
                  }
                });
              }
            );
          }
        ); */
      },

      saveDatabaseSource() {
        this.isSaving = true;
        var data = {
          "userID": this.user.id,
          "companyId": this.user.company_id,
          "source": this.source,
          "databases": this.database,
          "host": this.dbHost,
          "port": this.port,
          // "username": this.username,
          // "password": this.password,
        };
        if (this.source === 'mongo' && !!this.authSource) {
          data["authSource"] = this.authSource;
        }
        if (!!this.username && !!this.password) {
          data["username"] = this.username;
          data["password"] = this.password;
        }
        
        /* this.$store.dispatch(saveProject(this.name, this.description))
          .then(() => {
            // console.log("Project Save: ", data);
            this.$bvToast.toast('Project has been created successfully: ' + this.name, {
              title: 'Successful',
              autoHideDelay: 5000000,
              variant: 'success',
              solid: true
            });
            this.projects = this.getProjects();
            this.isSaving = false;
            this.$emit('success');
          })
          .catch(console.log)
          .finally(() => {
            this.isSaving = false;
          }); */
        
        axios.post(fullURL(`/extract`), data).then(({data}) => {
            console.log("Response: ", data);
            this.isSaving = false;
            // this.$store.state.files.projectList.push(data);
            this.dataSources.push(data);
            this.monitorTask(data.task_id);
          }
        );
      },
      
      formatDate(date) {
        // return moment(date).format(dateFormat);
        return moment(date).fromNow();
      },

      getProjects() {
        var projects = [];
        var files = {};
        this.$store.state.files.fileList.forEach(f => {
          files[f['_id']] = f['originalName'];
          // files.push(file);
        });
        this.$store.state.files.projectList.forEach(p => {
          var project = {};
          project['id'] = p.id;
          project['name'] = p.name;
          project['description'] = p.description;
          // console.log("Details: ", p.fieldMap, p.files);
          if (!!p.fieldMap) {
            project['fieldMap'] = {};
            Object.keys(p.fieldMap).forEach(file_id => {
              project['fieldMap'][files[file_id]] = p.fieldMap[file_id];
            });
          }
          if (!!p.files) {
            project['files'] = {};
            Object.keys(p.files).forEach(type => {
              project['files'][type] = files[p.files[type]];
            });
          }
          project['created'] = this.formatDate(p.createdAt);
          // project['name'] = p.name;
          projects.push(project);
        });
        return projects;
      },

      monitorTask(taskID) {
        registerListener(taskID, (event, data) => {
          if (event === 'success') {
            if (!!data.dataSource) {
              // this.$store.dispatch(initSegments())
              // .then(() => {
              //   console.log("All segments have been refreshed!!!");
              // })
              // .catch(console.log);
              // this.$store.dispatch(fetchUploadedFile(data.fileID))
              // .then(() => {
              //   this.$emit('success', data.fileID);
              // })
              // .catch(console.log)
              // .finally(() => {
              //   this.isSaving = false;
              // });
            } else {
              // this.$emit('fail', {'fileID': null, 'recordsLeft': data.records_left, 'rowCount': data.row_count});
            }
          } else if (event === 'failure') {
            console.log('The process failed', data.message);
          } else {
            return;
          }

          unregisterListener(taskID);
        });
      }
    },

    computed: {
      sources() {
        return [
          {text: "MySQL", value: 'mysql'},
          {text: "PostgresSQL", value: 'postgresql'},
          {text: "MongoDB", value: 'mongo'}
        ];
      },

      invalidSource() {
        var status = false;
        if (!this.source || !this.host || !this.port || !this.username || !this.password || !this.database) {
          status = true;
        }
        return (!this.isSaving) ? true : status;
      },

      defaultCols() {
        return ['id', 'name', 'description', 'created'];
      },

      metaList() {
        return this.$store.state.general.metas;
      },

      files() {
        // return this.getFiles();
        var files = [];
        this.$store.state.files.fileList.forEach(f => {
          f['createdAt'] = this.formatDate(f['createdAt']);
          files.push(f);
        });
        return files;
      },

      projects() {
        return this.getProjects();
      }
    }
  };
</script>

<style scoped>
  .title-description {
    font-weight: normal;
    font-size: .8em;
  }
</style>
